/**
 * Top-centered brand logo for every full-screen breathing exercise modal.
 * Rendered inside each modal (absolute, non-interactive) so patients always
 * see the clinic's branding + author credit while performing an exercise.
 */
const ExerciseTopLogo = () => (
  <div
    className="absolute top-3 left-1/2 -translate-x-1/2 z-20 pointer-events-none select-none flex flex-col items-center"
    data-testid="exercise-top-logo"
  >
    <img
      src="/logo-mains-nuages.png"
      alt="Physiothérapie Les Mains Nuages"
      className="h-8 sm:h-10 lg:h-12 w-auto"
      style={{ filter: 'drop-shadow(0 2px 6px rgba(15,32,64,0.25))' }}
    />
    <span
      className="mt-1 text-[10px] sm:text-xs text-slate-600/80 font-medium tracking-wide"
      data-testid="exercise-top-copyright"
    >
      Julien Jaccard © 2026
    </span>
  </div>
);

export default ExerciseTopLogo;
